import RichTextEditorField from './RichTextEditorField.component';

export default RichTextEditorField;
